<template>
	<div class="add-drug-container">
		<el-dialog :title="nameTitle" :visible.sync="dialogVisible" width="80%" top="5vh" v-loading="loading"
			class="add-drug-dialog" @close="handleClose"
			:close-on-press-escape="false"
			:close-on-click-modal="false"
			:modal-append-to-body="false"
			:append-to-body="false"
			:show-close="false">

			<!-- 自定义对话框标题 - 只有一个关闭按钮 -->
			<template slot="title">
        <div class="dialog-header">
          <span class="dialog-header-title">{{ nameTitle }}</span>
          <div class="header-buttons">
            <el-button type="text" @click="dialogVisible = false" icon="el-icon-close" class="close-button"></el-button>
          </div>
        </div>
      </template>
			
	<!-- 对话框内容区域 -->
	<div class="dialog-content">
		<!-- 上半部分：药品表单 - 占60%高度 -->
		<div class="top-section">
			<div class="form-top">
				<el-form :model="form" ref="topForm" label-width="120px" size="small" 
				:rules="formRules" :disabled="formDisabled || mode === 'view'">
				<!-- 第一行：药典名称、药品剂型、药品类型 - 左对齐 -->
				<el-row :gutter="0" class="fixed-form-row">
					<el-col :span="12">
						<el-form-item label="药典名称：" prop="drugCodeId" class="form-item-with-border">
						  <el-select v-model="form.drugCodeId" filterable remote
						    :remote-method="searchNameMethod" 
						    @focus="handleSelectFocus"
						    @change="handleNameChange" 
						    :loading="loading" 
						    v-el-select-infinite-scroll="handleScrollToBottom" 
						    style="width: 100%"
						    :popper-append-to-body="false"
						    ref="drugNameSelect"
						    @visible-change="handleSelectVisibleChange"
						    @blur="handleSelectBlur"
						    :popper-class="'custom-select-popper'"
						    :filterable="mode !== 'view'"
						    :remote="mode === 'add'"
						    clearable
						    placeholder="请选择或搜索药典名称">
						    
						    <!-- 选项组 -->
						    <el-group>
						      <!-- 固定头部容器 -->
						      <div class="select-header-wrapper" slot="header">
						        <div class="select-header">
						          <span class="header-item">药品名称</span>
						          <span class="header-item">规格</span>
						          <span class="header-item">药品编码</span>
						          <span class="header-item">剂型</span>
						          <span class="header-item">国药准字</span>
						          <span class="header-item">生产厂家</span>
						        </div>
						      </div>
						      
						      <!-- 选项列表 -->
						      <el-option v-for="item in NameOptions" :key="item._uid"
						        :label="item.label" :value="item.id">
						        <div class="option-row">
						          <el-tooltip :content="item.label" placement="top" :disabled="!isTextOverflow(item.label, 150)">
						            <span class="option-item" v-html="highlightText(item.label, currentQuery)"></span>
						          </el-tooltip>
						          <el-tooltip :content="item.specifications" placement="top" :disabled="!isTextOverflow(item.specifications, 100)">
						            <span class="option-item">{{ item.specifications }}</span>
						          </el-tooltip>
						          <el-tooltip :content="item.drugCode" placement="top" :disabled="!isTextOverflow(item.drugCode, 120)">
						            <span class="option-item">{{ item.drugCode }}</span>
						          </el-tooltip>
						          <el-tooltip :content="item.dosageForm" placement="top" :disabled="!isTextOverflow(item.dosageForm, 80)">
						            <span class="option-item">{{ item.dosageForm }}</span>
						          </el-tooltip>
						          <el-tooltip :content="item.approvalNumber" placement="top" :disabled="!isTextOverflow(item.approvalNumber, 120)">
						            <span class="option-item">{{ item.approvalNumber }}</span>
						          </el-tooltip>
						          <el-tooltip :content="item.licensorChinese" placement="top" :disabled="!isTextOverflow(item.licensorChinese, 150)">
						            <span class="option-item">{{ item.licensorChinese }}</span>
						          </el-tooltip>
						        </div>
						      </el-option>
						    </el-group>
						    
						    <!-- 无数据和加载提示保持不变 -->
						    <div v-if="showNoDataPrompt && currentQuery" slot="empty" class="no-data-prompt">
						      <i class="el-icon-warning"></i>
						      <p>本位码信息中暂无 '<span class="highlight-query">{{ currentQuery }}</span>' 数据内容</p>
						      <el-button type="text" class="quick-add-link" @click="openQuickAddDialog">
						        请点此手动添加
						      </el-button>
						    </div>
						    
						    <div v-else-if="loading" slot="empty" class="load-more">
						      <i class="el-icon-loading"></i> 加载中...
						    </div>
						    <div v-else-if="scrollLoading" slot="empty" class="load-more">
						      <i class="el-icon-loading"></i> 加载更多...
						    </div>
						    <div v-else-if="!hasMore && NameOptions.length > 0" slot="empty" class="load-more">
						      没有更多数据了
						    </div>
						    <div v-else-if="NameOptions.length === 0 && !currentQuery" slot="empty" class="load-more">
						      请输入药品名称进行搜索
						    </div>
						  </el-select>
						</el-form-item>
					</el-col>
						
					<el-col :span="6">
					  <el-form-item label="药品剂型：" prop="dosageForm" class="form-item-with-border form-item-left-align">
					    <el-select v-model="form.dosageForm" placeholder="请选择药品剂型" filterable clearable
					      style="width: 100%" :disabled="mode !== 'view'"
					      @change="handleDosageFormChange"
					      :filterable="mode !== 'view'"> <!-- 在查看模式下禁用下拉框 -->
					      
					      <el-option v-for="item in dosageFormOptions" :key="item.id"
					        :label="item.dosageName" :value="item.id">
					        <span style="float: left">{{ item.dosageName }}</span>
					        <span v-if="item.code"
					          style="float: right; color: #8492a6; font-size: 12px">
					          {{ item.code }}
					        </span>
					      </el-option>
					    </el-select>
					  </el-form-item>
					</el-col>
					
					<el-col :span="6">
						<el-form-item label="药品类型：" class="form-item-with-border form-item-left-align">
							<el-select v-model="form.drugType" style="width: 100%;" disabled placeholder=''>
								<el-option v-for="item in drugTypeOption" :key="item.id" 
									:label="item.label" :value="item.id">
									<span>{{ item.label }}</span>
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				
				<!-- 标签页区域 - 优化样式 添加固定高度容器 -->
				<div class="tab-content-fixed-height">
					<el-tabs v-model="activeTab" class="form-tabs">
						<!-- 在标签页区域，确保field-config正确绑定 -->
						<el-tab-pane label="基本内容" name="basic">
						  <basic-info 
						    ref="basicInfo" 
						    :form="form"
						    :form-disabled="formDisabled || mode === 'view'" 
						    :mode="mode"
						    :field-config="fieldConfigs.basic"
						    @update="handleFormUpdate"
						    :disable-packing-quantity="disablePackingQuantity"
						  > 
						  </basic-info>
						</el-tab-pane>

						<el-tab-pane label="扩展信息" name="extended">
							<kz-info ref="kzInfo" :form="form" :form-disabled="formDisabled || mode === 'view'"
								:mode="mode" :field-config="fieldConfigs.extended" @update="handleFormUpdateF3">
							</kz-info>
						</el-tab-pane>

						<el-tab-pane label="使用注意" name="usage">
							<use-info ref="useInfo" :form="form" :form-disabled="formDisabled || mode === 'view'"
								:mode="mode" :field-config="fieldConfigs.usage" @update="handleFormUpdateF4">
							</use-info>
						</el-tab-pane>
					</el-tabs>
				</div>
			</el-form>
		</div>
	</div>

	<!-- 下半部分：生产厂家表格 - 占40%高度 -->
	<div class="bottom-section">
      <div class="section-header">
        <div class="section-title">
          <span>生产厂家信息</span>
        </div>
        <div class="section-actions" v-if="mode !== 'view'">
          <el-button type="primary" size="mini" icon="el-icon-plus" @click="goToManufacturerPage('add')">
            添加厂商
          </el-button>
        </div>
      </div>
      
      <div class="manufacturer-table">
        <el-table :data="manufacturerData" border style="width: 100%;" height="100%"
          @current-change="handleManufacturerSelect">

          <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
          <el-table-column prop="manufacturer" label="生产厂家" width="180"></el-table-column>
          <el-table-column prop="status" label="有效状态" width="100">
            <template slot-scope="{ row }">
              <span :style="{color: row.status === 1 ? '#00557f' : '#f56c6c', fontWeight: 'bold'}">
                {{ statusMap[row.status] }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="expyDate" label="有效期天数" width="100"></el-table-column>
          <!-- 新增批准文号列 -->
          <el-table-column prop="manuLotnum" label="批准文号" width="150"></el-table-column>
          <el-table-column prop="orplc" label="产地" width="120"></el-table-column>
          <el-table-column prop="drugTracB" label="强制追溯码" width="120">
            <template slot-scope="{ row }">
              <span :style="{color: row.drugTracB === 1 ? 'brown' : '#909399', fontWeight: 'bold'}">
                {{ drugTracBMap[row.drugTracB] }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="ratio" label="自付比例" width="100"></el-table-column>
          <el-table-column prop="bidCnt" label="中标次数" width="100"></el-table-column>
          <el-table-column prop="netCode" label="网采编码" width="120"></el-table-column>
          <el-table-column prop="chsName" label="医保名称" width="100"></el-table-column>
          <el-table-column prop="chsCode" label="医保编码" width="100"></el-table-column>
          <el-table-column prop="ypId" label="ypId" width="120"></el-table-column>
          <el-table-column label="操作" width="150" fixed="right" align="center" v-if="mode !== 'view'">
            <template slot-scope="{ row, $index }">
              <el-button type="text" size="mini" icon="el-icon-edit" 
                @click="handleEditManufacturer(row, $index)">
                修改
              </el-button>
              <el-button type="text" size="mini" icon="el-icon-delete" 
                @click="handleDeleteManufacturer(row, $index)" style="color: #f56c6c">
                移除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
	</div>
	
	<!-- 底部操作按钮 -->
	<div slot="footer" class="dialog-footer" v-if="mode !== 'view'">
		<el-button size="mini" type="primary" @click="submitForm">
			确认添加
		</el-button>
		<el-button size="mini" @click="dialogVisible = false">关闭</el-button>
	</div>
	<div slot="footer" class="dialog-footer" v-else>
		<el-button size="mini" @click="dialogVisible = false">关闭</el-button>
	</div>
	
	<!-- 厂家信息编辑模态框 -->
	<man-facter 
	  :visible="manufacturerDialogVisible" 
	  :mode="manufacturerMode"
	  :manufacturer-data="currentManufacturer" 
	  :drug-data="form" 
	  :title="manufacturerTitle"
	  :auto-open-quick-add="true"
	  @close="handleManufacturerClose" 
	  @save="handleManufacturerSave">
	</man-facter>
	
	<!-- 快速添加本位码信息弹窗 -->
	<!-- 快速添加本位码信息弹窗 -->
	<el-dialog title="快速添加本位码信息" :visible.sync="quickAddDialogVisible" width="500px" 
	  :close-on-click-modal="false" :append-to-body="true" class="quick-add-dialog"
	  :before-close="handleQuickAddClose">
	  
	  <el-form :model="quickAddForm" ref="quickAddForm" label-width="100px" size="small">
	    <el-form-item label="厂家名称：" prop="manufacturer" required>
	      <el-input
	        v-model="quickAddForm.manufacturer"
	        placeholder="请输入生产厂家公司名称"
	        :disabled="true"
	      ></el-input>
	    </el-form-item>
	    
	    <el-form-item label="药品名称：" prop="productName" 
	      :rules="[{ required: true, message: '请输入产品名称', trigger: 'blur' }]">
	      <el-input v-model="quickAddForm.productName" placeholder="请输入药品产品名称" :disabled="true"></el-input>
	    </el-form-item>
	    
	    <el-form-item label="药品规格：" prop="specifications" 
	      :rules="[{ required: true, message: '请输入药品规格', trigger: 'blur' }]">
	      <el-input v-model="quickAddForm.specifications" placeholder="请输入药品规格描述" :disabled="true"></el-input>
	    </el-form-item>
	    <el-form-item label="药品剂型：" prop="dosageForm"
	      :rules="[{ required: true, message: '请选择药品剂型', trigger: 'change' }]">
	      <el-select v-model="quickAddForm.dosageForm" placeholder="请选择剂型" filterable clearable style="width: 100%">
	        <el-option
	          v-for="item in dosageFormOptions"
	          :key="item.id"
	          :label="item.dosageName"
	          :value="item.id"
	        ></el-option>
	      </el-select>
	    </el-form-item>
	  </el-form>
	  
	  <span slot="footer" class="dialog-footer">
	    <el-button size="small" @click="handleQuickAddClose">取消</el-button>
	    <el-button
	      size="small"
	      type="primary"
	      @click="handleQuickAddSubmit"
	      :loading="quickAddLoading"
	      :disabled="quickAddLoading"
	    >
	      确定添加
	    </el-button>
	  </span>
	</el-dialog>
		</el-dialog>
	</div>
</template>

<script>
// 引入组件
import BasicInfo from './F2.vue';
import kzInfo from './F3.vue';
import useInfo from './F4.vue';
import ManFacter from './ManFacter.vue';
import { pinyin } from 'pinyin-pro';

// 引入接口
import { FieldList } from "@/api/Outpatient/field.js";
import { getDInfo, getDInfos, getDosageForm, getManufacturer } from "@/api/MedicenCata.js";
import { addDocTDrugCode } from "@/api/systemCatalogue/MedicenCata.js";

import { addDrugInformation, updateDrugInformation } from "@/api/MedicenCata.js";
import { dict } from "@/api/staff/staff.js";
import { getCJSomeWare } from "@/api/systemCatalogue/Western.js";
// 自定义指令：实现下拉框无限滚动
const elSelectInfiniteScroll = {
  bind(el, binding) {
    const SELECTWRAPPER_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
    if (SELECTWRAPPER_DOM) {
      SELECTWRAPPER_DOM.addEventListener('scroll', function() {
        const condition = this.scrollHeight - this.scrollTop - 1 <= this.clientHeight;
        if (condition) {
          binding.value();
        }
      });
    }
  }
};

export default {
  name: 'AddDrugDialog',
    props: {
      visible: Boolean,
      drugData: Object,
      // 新增
      drugId: {
        type: [String, Number],
        default: ''
      },
      approvalLicenceNo: {
        type: String,
        default: ''
      },
      prepnTypeDesc: {
        type: String,
        default: ''
      }
    },
	components: {
	  BasicInfo,
	  kzInfo,
	  useInfo,
	  ManFacter
	},
	directives: {
		'el-select-infinite-scroll': elSelectInfiniteScroll
	},
  data() {
    return {
      // 对话框相关
      dialogVisible: false,  // 内部对话框状态
      nameTitle: '添加新的西药目录档案', // 默认标题
      mode: 'add',
      loading: false,
      
      // 表单数据
	  form: {
		state: 1,
		kcId: 0,
		drugCodeId: '',
		dosageForm: '',
		drugType: 1, // 默认西药
		drugName: '',
		drugCodeName: '',
		code: '',
		drugSpec: '',
		dosForm: '',
		pyCode: '',
		mrsId: '',
		isBar: this.drugData.isBar !== undefined ? this.drugData.isBar : 1, // 默认启用追溯码
		expensiveType: 1, // 新增：贵重类型，默认为1（普价）
	  },
      
      // 表单验证规则
      formRules: {
        drugCodeId: [{
          required: true,
          message: '请选择药典名称',
          trigger: 'change'
        }],
        dosageForm: [{
          required: true,
          message: '请选择药品剂型',
          trigger: 'change'
        }]
      },
      
      // 药典名称搜索相关
      NameOptions: [],
      currentQuery: '',
      pageNum: 1,
      pageSize: 48,
      hasMore: true,
      scrollLoading: false,
      showNoDataPrompt: false,
      
      // 字段配置
      fieldConfigs: {
        basic: [],
        extended: [],
        usage: []
      },
	  // 添加：控制字段配置是否已加载的标志
	  fieldConfigsLoaded: false,
		  
      currentTabGroup: 'basic',
      
      // 药品剂型选项
      dosageFormOptions: [],
      drugTypeOption: [
        { id: 1, label: '西药' },
        { id: 2, label: '成药' },
        { id: 3, label: '卫材' },
        { id: 4, label: '血液' },
        { id: 5, label: '疫苗' }
      ],
      
      // 选项卡
      activeTab: 'basic',
      
      // 表单状态
      formDisabled: false,
      disablePackingQuantity: false,
      
      // 生产厂家相关
      manufacturerData: [],
      manufacturerDialogVisible: false,
      manufacturerMode: 'add',
      currentManufacturer: null,
      currentManufacturerIndex: -1, // 新增：记录当前编辑的厂家索引
      // 快速添加相关
      quickAddDialogVisible: false,
      quickAddLoading: false,
      quickAddForm: {
        manufacturer: "",
        productName: "",
        specifications: "",
		dosageForm: '',               // 剂型
		approvalLicenceNo: '' // 新增
      },
      manufacturerValid: null,        // null-未验证, true-存在, false-不存在
	  selectedManufacturer: null,     // 存储从 getCJSomeWare 返回的厂家数据
      // 状态映射
      statusMap: { 0: '禁用', 1: '可用' },
      drugTracBMap: { 0: '否', 1: '是' }
    };
  },
	computed: {
	  // 计算厂家对话框标题
	  manufacturerTitle() {
	    if (this.manufacturerMode === 'add') {
	      return `为西药品（${this.form.drugName || '未命名'}）添加新的厂商信息`;
	    } else if (this.manufacturerMode === 'edit') {
	      return `更新西药品（${this.form.drugName || '未命名'}）的厂商信息`;
	    } else {
	      return '厂家信息';
	    }
	  }
	},
  // 监听标签页切换
    watch: {
      'form.kcId': {
        immediate: true,
        handler(newVal) {
          this.disablePackingQuantity = Number(newVal) === 1;
        }
      },
       // 监听visible属性变化
       visible: {
         immediate: true,
         async handler(newVal) {
           console.log('AddDrugDialog visible变化:', newVal);
           this.dialogVisible = newVal;
           if (newVal) {
             this.nameTitle = '添加新的西药目录档案';
             await this.openAddModel({ mode: 'add', label: '添加新的西药目录档案' });
             // 打开对话框后，自动打开快速添加模态框
             this.$nextTick(() => {
               this.openQuickAddDialog();
             });
           }
         }
       },
	// 监听内部dialogVisible变化
	  dialogVisible(newVal) {
	    console.log('AddDrugDialog dialogVisible变化:', newVal);
	    // 触发更新事件，同步到父组件
	    this.$emit('update:visible', newVal);
	  },
	// 添加对标签页切换的监听
	  activeTab(newVal, oldVal) {
	    if (newVal !== oldVal) {
	      // 标签页切换后，修复滚动容器
	      this.$nextTick(() => {
	        setTimeout(() => {
	          this.fixScrollContainers();
	        }, 100);
	      });
	    }
	  }
	},
	mounted() {
	  console.log('父组件 mounted, visible:', this.visible);
	  this.dialogVisible = this.visible;
	  
	},
	methods: {
		// 初始化表单数据
		initForm() {
		  console.log('初始化AddDrugDialog表单数据:', this.drugData);
		  if (this.drugData) {
		    // 从父组件传递的数据初始化表单
		    this.form = {
		      state: 1,
		      kcId: 0,
		      drugCodeId: '',
		      dosageForm: '',
		      drugType: 1,
		      drugName: this.drugData.drugName || '',
		      drugCodeName: '',
		      code: '',
		      drugSpec: this.drugData.spec || '',
		      dosForm: '',
		      pyCode: this.getFirstLetter(this.drugData.drugName || ''),
		      mrsId: '',
		      expensiveType: 1,
		      // 其他从父组件传递的数据
		      pacCnt: this.drugData.pacCnt || 1,
		      approvalLicenceNo: this.drugData.approvalLicenceNo || '',
		      manufacturer: this.drugData.manufacturer || '',
		      manufacturerId: this.drugData.manufacturerId || '',
		      remark: this.drugData.remark || ''
		    };
		    
		    // 如果药品名称不为空，生成拼音码
		    if (this.drugData.drugName) {
		      this.form.pyCode = this.getFirstLetter(this.drugData.drugName);
		    }
		    
		    // 如果从父组件传递了剂型信息，尝试设置
		    if (this.drugData.dosageForm) {
		      console.log('从父组件传递了剂型信息:', this.drugData.dosageForm);
		      this.form.dosageForm = this.drugData.dosageForm;
		      this.form.dosForm = this.drugData.dosageForm;
		      this.form.dosformName = this.drugData.dosageFormName || '';
		    }
		  }
		},
		// 检查并修复滚动容器
		fixScrollContainers() {
			this.$nextTick(() => {
			  // 获取所有标签页内容容器
			  const tabContents = [
				this.$refs.basicTabContent,
				this.$refs.extendedTabContent,
				this.$refs.usageTabContent
			  ];
			  
			  tabContents.forEach((container, index) => {
				if (container) {
				  const scrollContainer = container.querySelector('.form-scroll-container');
				  if (scrollContainer) {
					// 确保滚动容器有正确的高度
					const computedHeight = container.clientHeight;
					if (computedHeight > 0) {
					  scrollContainer.style.height = `${computedHeight}px`;
					}
					
					// 检查内容是否溢出
					const isOverflowing = scrollContainer.scrollHeight > scrollContainer.clientHeight;
					if (isOverflowing) {
					  scrollContainer.style.overflowY = 'scroll';
					  console.log(`标签页 ${index + 1} 内容溢出，已启用滚动`);
					}
				  }
				}
			  });
			});
		},
		
	// 在打开对话框时调用
	async openAddModel(param) {
	  console.log('openAddModel被调用，参数:', param);
	  this.dialogVisible = true;
	  this.nameTitle = param.label || '新增西药目录';
	  this.mode = param.mode || 'add';
	
	  try {
	    this.loading = true;
	    this.fieldConfigsLoaded = false;
	    await this.loadFieldConfigs(); // 这里会调用 FieldList
	    console.log('字段配置加载完成:', this.fieldConfigs);
	    await this.loadDosageFormOptions();
	
	    if ((this.mode === 'edit' || this.mode === 'view') && param.id) {
	      await this.loadEditData(param.id);
	    } else {
	      this.resetForm();
	      if (this.drugData && Object.keys(this.drugData).length > 0) {
	        this.initForm();
	      }
	    }
	
	    this.$nextTick(() => {
	      this.ensureFieldConfigPassed();
	      this.fixScrollContainers();
	    });
	
	  } catch (error) {
	    console.error('加载数据失败:', error);
	    this.$message.error('打开对话框失败');
	  } finally {
	    this.loading = false;
	  }
	},
	
	// 初始化表单数据
	initFormData(params) {
	  console.log('初始化表单数据:', params);
	  
	  // 从路由参数中填充表单
	  Object.keys(params).forEach(key => {
		if (this.form.hasOwnProperty(key)) {
		  this.form[key] = params[key] || this.form[key];
		}
	  });
	  
	  // 特殊处理：药品名称
	  if (params.drugName) {
		this.form.drugName = params.drugName;
	  }
	  
	  // 特殊处理：包装数量
	  if (params.pacCnt) {
		this.form.pacCnt = Number(params.pacCnt) || 1;
	  }
	  
	  // 特殊处理：规格
	  if (params.spec) {
		this.form.spec = params.spec;
	  }
	  
	  // 特殊处理：批准文号
	  if (params.approvalLicenceNo) {
		this.form.approvalLicenceNo = params.approvalLicenceNo;
	  }
	  
	  // 特殊处理：生产厂家
	  if (params.manufacturer) {
		this.form.manufacturer = params.manufacturer;
	  }
	  
	  console.log('初始化后的表单数据:', this.form);
	},
		
    // 确保字段配置传递给子组件
    ensureFieldConfigPassed() {
      console.log('ensureFieldConfigPassed 被调用，当前字段配置状态:', this.fieldConfigsLoaded);
      if (this.fieldConfigsLoaded) {
        console.log('字段配置已加载，更新子组件');
        this.updateBasicInfoFieldConfig();
        if (this.mode === 'edit' || this.mode === 'view') {
          this.updateExtendedInfoFieldConfig();
          this.updateUsageInfoFieldConfig();
        }
      } else {
        console.warn('字段配置尚未加载，跳过更新');
      }
    },
    
    // 新增：更新基本内容字段配置
    updateBasicInfoFieldConfig() {
      console.log('更新F2子组件字段配置，配置数据:', this.fieldConfigs.basic);
      console.log('F2组件实例:', this.$refs.basicInfo);
      
      if (this.$refs.basicInfo) {
        console.log('F2组件存在，配置将通过props传递');
        
        // 注意：配置已经通过:field-config="fieldConfigs.basic"在模板中传递
        // 这里只需要确保F2组件能正确接收和处理配置
        
        // 检查F2组件是否有处理配置的方法
        if (typeof this.$refs.basicInfo.processFieldConfig === 'function') {
          console.log('调用F2组件的processFieldConfig方法');
          this.$refs.basicInfo.processFieldConfig(this.fieldConfigs.basic);
        } else if (typeof this.$refs.basicInfo.setFieldConfig === 'function') {
          console.log('调用F2组件的setFieldConfig方法');
          this.$refs.basicInfo.setFieldConfig(this.fieldConfigs.basic);
        } else {
          console.log('F2组件没有处理配置的方法，依赖props自动传递');
        }
      } else {
        console.warn('F2子组件未找到，等待组件挂载');
        
        // 延迟重试
        setTimeout(() => {
          this.updateBasicInfoFieldConfig();
        }, 100);
      }
    },
    
    // 新增：更新扩展信息字段配置
    updateExtendedInfoFieldConfig() {
      if (this.$refs.kzInfo && typeof this.$refs.kzInfo.setFieldConfig === 'function') {
        this.$refs.kzInfo.setFieldConfig(this.fieldConfigs.extended);
      }
    },
    
    // 新增：更新使用注意字段配置
    updateUsageInfoFieldConfig() {
      if (this.$refs.useInfo && typeof this.$refs.useInfo.setFieldConfig === 'function') {
        this.$refs.useInfo.setFieldConfig(this.fieldConfigs.usage);
      }
    },
    
    // 加载药品剂型选项
    async loadDosageFormOptions() {
      try {
        console.log('开始加载药品剂型选项');
        
        const response = await getDosageForm({
          pageNum: 1,
          pageSize: 1000
        });
    
        if (response.code === 200) {
          const data = response.data || response.data.list || response.data || [];
          console.log('获取到的剂型选项数据:', data);
          
          this.dosageFormOptions = data.map(item => ({
            id: item.id || item.dosageFormId || item.value,
            label: item.name || item.dosageFormName || item.label || item.text,
            dosageName: item.dosageName || item.name || item.label || item.text,
            code: item.code,
            ...item
          }));
          
          console.log('格式化后的剂型选项:', this.dosageFormOptions);
          
          // 加载完成后，如果当前有已选择的药品，尝试自动设置剂型
          if (this.form.drugCodeId && this.form.drugName) {
            console.log('剂型选项加载完成，尝试为当前药品设置剂型');
            this.autoSetDosageFormFromCurrentDrug();
          }
        } else {
          console.error('获取药品剂型数据失败:', response.message);
          this.$message.error(response.message || '获取药品剂型数据失败');
          this.dosageFormOptions = [];
        }
      } catch (error) {
        console.error('获取药品剂型数据失败:', error);
        this.$message.error('获取药品剂型数据失败');
        this.dosageFormOptions = [];
      }
    },
    
    // 从当前药品自动设置剂型
    autoSetDosageFormFromCurrentDrug() {
      if (!this.form.drugName || this.dosageFormOptions.length === 0) {
        return;
      }
      
      // 尝试从当前药品名称中提取可能的剂型信息
      const drugName = this.form.drugName;
      console.log('尝试从药品名称中提取剂型:', drugName);
      
      // 常见的剂型关键词
      const dosageTypeKeywords = [
        '片剂', '胶囊', '注射液', '颗粒', '口服液', '软膏', '乳膏', '凝胶',
        '滴眼液', '滴耳液', '喷雾剂', '气雾剂', '栓剂', '贴剂', '丸剂',
        '散剂', '糖浆', '酊剂', '洗剂', '擦剂', '注射剂', '输液'
      ];
      
      // 在药品名称中查找剂型关键词
      for (const keyword of dosageTypeKeywords) {
        if (drugName.includes(keyword)) {
          console.log('在药品名称中找到剂型关键词:', keyword);
          
          // 查找匹配的剂型选项
          const matchedDosageForm = this.dosageFormOptions.find(item => 
            item.dosageName && item.dosageName.includes(keyword) ||
            item.label && item.label.includes(keyword)
          );
          
          if (matchedDosageForm) {
            console.log('根据关键词找到匹配的剂型:', matchedDosageForm);
            this.form.dosageForm = matchedDosageForm.id;
            this.form.dosForm = matchedDosageForm.id;
            this.form.dosformName = matchedDosageForm.dosageName || matchedDosageForm.label;
            
            this.$message.success(`已自动设置剂型: ${matchedDosageForm.dosageName || matchedDosageForm.label}`);
            return;
          }
        }
      }
      
      console.log('未能从药品名称中自动识别剂型');
    },
    
    // 修改：加载字段配置
    async loadFieldConfigs() {
      try {
        console.log('开始调用FieldList接口加载字段配置');
        const res = await FieldList({
          pageSize: 999,
          pageNum: 1,
          typeCode: 1,
        });
        if (res.code === 200) {
          console.log('FieldList接口调用成功，返回数据:', res);
          await this.processFieldConfigs(res.data.content || []);
          this.fieldConfigsLoaded = true;
          console.log('字段配置加载完成:', this.fieldConfigs);
        } else {
          console.error('FieldList接口返回错误:', res.message);
          this.fieldConfigsLoaded = true; // 即使失败也设置为 true
        }
      } catch (error) {
        console.error('调用FieldList接口失败:', error);
        this.fieldConfigsLoaded = true; // 避免无限重试
      }
    },
    
    // 新增：处理字段配置
    async processFieldConfigs(fieldData) {
      return new Promise((resolve) => {
        // 清空现有配置
        this.fieldConfigs = {
          basic: [],
          extended: [],
          usage: []
        };
    
        if (!fieldData || fieldData.length === 0) {
          console.warn('字段配置数据为空');
          resolve();
          return;
        }
    
        // 按模块分类字段
        fieldData.forEach(field => {
          const moduleCode = field.moduleCode || 1;
          
          // 格式化字段配置
          const formattedField = this.formatFieldConfig(field);
          
          // 根据模块代码分类
          switch (moduleCode) {
            case 2: // 基本内容模块
              this.fieldConfigs.basic.push(formattedField);
              break;
            case 3: // 扩展信息模块
              this.fieldConfigs.extended.push(formattedField);
              break;
            case 4: // 使用注意模块
              this.fieldConfigs.usage.push(formattedField);
              break;
            default:
              console.warn('未知模块代码:', moduleCode, field);
          }
        });
    
        console.log('处理后的字段配置:', this.fieldConfigs);
        resolve();
      });
    },
    
    // 新增：格式化字段配置
    formatFieldConfig(field) {
      const fieldConfig = {
        fieldCode: field.fieldCode || '',
        fieldName: field.fieldName || '',
        displayName: field.displayName || '',
        isRequired: field.isRequired || false,
        isDisplay: field.isDisplay !== undefined ? field.isDisplay : true,
        isEdit: field.isEdit !== undefined ? field.isEdit : true,
        fieldType: field.fieldType || 'input',
        dataType: field.dataType || 'string',
        fieldLength: field.fieldLength || 0,
        fieldSequence: field.fieldSequence || 0,
        defaultValue: field.defaultValue || '',
        options: field.options || [],
        validationRules: field.validationRules || [],
        helpText: field.helpText || '',
        placeholder: field.placeholder || '',
        ...field
      };
      
      // 根据fieldType设置inputBoxType
      switch (fieldConfig.fieldType) {
        case 'select':
          fieldConfig.inputBoxType = 'selected';
          break;
        case 'number':
          fieldConfig.inputBoxType = 'inputNumber';
          break;
        case 'switch':
          fieldConfig.inputBoxType = 'switch';
          break;
        case 'checkbox':
          fieldConfig.inputBoxType = 'checked';
          break;
        case 'cascader':
          fieldConfig.inputBoxType = 'cascader';
          break;
        case 'date':
        case 'datetime':
          fieldConfig.inputBoxType = 'dateTime';
          break;
        default:
          fieldConfig.inputBoxType = 'input';
      }
      
      return fieldConfig;
    },
    
    // 分类字段配置
    classifyFieldConfigs(fieldData) {
      const fieldConfigsByModule = {
        module1: [],
        module2: [],
        module3: [],
        module4: []
      };

      fieldData.forEach(field => {
        const moduleCode = field.moduleCode || 1;
        const moduleKey = `module${moduleCode}`;

        if (fieldConfigsByModule[moduleKey]) {
          fieldConfigsByModule[moduleKey].push(field);
        }
      });

      this.fieldConfigs.basic = fieldConfigsByModule.module2;
      this.fieldConfigs.extended = fieldConfigsByModule.module3;
      this.fieldConfigs.usage = fieldConfigsByModule.module4;
    },
    
    // 加载编辑数据
    async loadEditData(id) {
      try {
        this.loading = true;
        let res = await getDInfos({ id: id });
        
        if (res.code === 200) {
          this.resetForm();
          const kcId = res.data.kcId || 0;
          
          this.form = {
            ...this.form,
            ...res.data,
            state: String(res.data.state || '1'),
            kcId: kcId
          };
          
          // 确保expensiveType有值，如果没有则使用默认值1
          if (res.data.expensiveType === undefined || res.data.expensiveType === null) {
            this.form.expensiveType = 1;
          }
          
          this.disablePackingQuantity = Number(kcId) === 1;
          
          // 处理药典名称显示
          await this.handleDrugCodeDisplay(res.data);
          
          // 处理药品剂型显示
          await this.handleDosageFormDisplay(res.data);
          
          // 处理厂家信息
          await this.handleManufacturerData(res.data);
        }
      } catch (error) {
        console.error('加载编辑数据失败:', error);
        this.$message.error('加载数据失败');
      } finally {
        this.loading = false;
      }
    },
    
    // 处理药典名称显示
    async handleDrugCodeDisplay(formData) {
      // 在编辑和查看模式下，显示药典名称而不是ID
      if ((this.mode === 'edit' || this.mode === 'view') && formData.drugCodeName) {
        // 设置药典名称显示
        this.form.drugCodeName = formData.drugCodeName;
        
        // 确保form.drugCodeId正确设置
        this.form.drugCodeId = formData.drugCodeId;
        
        // 在编辑模式下，初始时加载当前药典
        if (this.mode === 'edit' && formData.drugCodeName) {
          // 设置当前查询条件
          this.currentQuery = formData.drugCodeName;
          
          // 在编辑模式下，加载当前药典到选项列表中
          await this.loadCurrentDrugToOptions(formData);
        } else if (this.mode === 'view') {
          // 在查看模式下，只需要设置当前查询条件
          this.currentQuery = formData.drugCodeName;
          
          // 在查看模式下，将当前药典添加到选项列表中
          this.NameOptions = [{
            id: formData.drugCodeId,
            label: formData.drugCodeName,
            drugCode: formData.code || '',
            specifications: formData.drugSpec || '',
            dosageForm: formData.dosformName || '',
            approvalNumber: formData.approvalNumber || '',
            licensorChinese: formData.manufacturer || '',
            _uid: Math.random().toString(36).substr(2, 9)
          }];
        }
      }
    },
    
    // 加载当前药典到选项列表
    async loadCurrentDrugToOptions(formData) {
      try {
        // 在编辑模式下，先加载当前药典
        this.NameOptions = [{
          id: formData.drugCodeId,
          label: formData.drugCodeName,
          drugCode: formData.code || '',
          specifications: formData.drugSpec || '',
          dosageForm: formData.dosformName || '',
          approvalNumber: formData.approvalNumber || '',
          licensorChinese: formData.manufacturer || '',
          _uid: Math.random().toString(36).substr(2, 9)
        }];
        
        // 在编辑模式下，同时加载一些默认的药典数据，方便用户选择
        await this.loadDefaultDrugOptions();
      } catch (error) {
        console.error('加载药典选项失败:', error);
      }
    },
    
    // 加载默认药典选项
    async loadDefaultDrugOptions() {
      try {
        // 加载默认的药典数据（例如：加载前20条）
        const res = await getDInfo({
          productName: '',
          pageNum: 1,
          pageSize: 20
        });
        
        if (res.code === 200 && res.data.content && res.data.content.length > 0) {
          // 将默认数据添加到选项列表中，排除重复项
          const defaultOptions = res.data.content.map(v => ({
            id: v.id,
            label: v.productName,
            drugCode: v.drugCode || '',
            specifications: v.specifications || '',
            dosageForm: v.dosageForm || '',
            approvalNumber: v.approvalNumber || '',
            licensorChinese: v.licensorChinese || '',
            _uid: Math.random().toString(36).substr(2, 9)
          }));
          
          // 合并选项，排除重复的ID
          const existingIds = this.NameOptions.map(item => item.id);
          const newOptions = defaultOptions.filter(item => !existingIds.includes(item.id));
          
          this.NameOptions = [...this.NameOptions, ...newOptions];
          this.hasMore = res.data.content.length >= 20;
        }
      } catch (error) {
        console.error('加载默认药典选项失败:', error);
      }
    },
    
    // 处理药品剂型显示
    async handleDosageFormDisplay(formData) {
      // 在编辑和查看模式下，确保药品剂型正确显示
      if ((this.mode === 'edit' || this.mode === 'view') && formData.dosForm) {
        const dosageFormId = formData.dosForm;
        const dosformName = formData.dosformName || '';
        
        // 查找剂型选项中是否包含当前剂型
        const dosageExists = this.dosageFormOptions.some(item => 
          item.id == dosageFormId
        );
        
        if (!dosageExists && dosformName) {
          // 如果剂型选项中不存在，将其添加到选项中
          this.dosageFormOptions.unshift({
            id: dosageFormId,
            dosageName: dosformName,
            label: dosformName
          });
        }
        
        // 确保form.dosageForm正确设置
        this.form.dosageForm = dosageFormId;
      }
    },
    
    // 处理厂家信息数据
    async handleManufacturerData(formData) {
      let manufacturerList = [];
      
      if (formData.list && Array.isArray(formData.list)) {
        manufacturerList = formData.list;
      } else if (formData.manufacturerList && Array.isArray(formData.manufacturerList)) {
        manufacturerList = formData.manufacturerList;
      }
      
      if (manufacturerList.length > 0) {
        this.manufacturerData = manufacturerList.map(item => ({
          id: item.prodentpId,
          prodentpId: item.prodentpId,
          manufacturer: item.manufacturer || item.prodentpName || '未知厂家',
          status: item.status || 1,
          expyDate: item.expyDate || '',
          orplc: item.orplc || '',
          drugTracB: item.drugTracB || 0,
          drugTracMaxId: item.drugTracMaxId || '',
          drugTracMinId: item.drugTracMinId || '',
          drugTracMaxCnt: item.drugTracMaxCnt || '',
          ratio: item.ratio || '',
          bidCnt: item.bidCnt || '',
          manuLotnum: item.manuLotnum || '',
          netCode: item.netCode || '',
          chsName: item.chsName || '',
          chsCode: item.chsCode || '',
          ypId: item.ypId || '',
          regModel: item.regModel || '',
          regSpc: item.regSpc || '',
          coding: item.coding || ''
        }));
      } else {
        this.manufacturerData = [];
      }
    },
    
    // 检查文本是否溢出
    isTextOverflow(text, maxWidth) {
      if (!text) return false;
      
      // 创建一个临时元素来测量文本宽度
      const tempSpan = document.createElement('span');
      tempSpan.style.visibility = 'hidden';
      tempSpan.style.position = 'absolute';
      tempSpan.style.whiteSpace = 'nowrap';
      tempSpan.style.fontSize = '12px';
      tempSpan.style.fontFamily = 'inherit';
      tempSpan.innerText = text;
      
      document.body.appendChild(tempSpan);
      const textWidth = tempSpan.offsetWidth;
      document.body.removeChild(tempSpan);
      
      return textWidth > maxWidth;
    },
    
    // 高亮显示搜索关键词
    highlightText(text, query) {
      if (!text || !query) return text;

      try {
        // 创建正则表达式，不区分大小写，全局匹配
        const regex = new RegExp(query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi');

        // 替换匹配的文本，添加高亮样式
        return text.replace(regex, (match) => {
          return `<span style="background-color: #fffe76; color: #000; font-weight: bold;">${match}</span>`;
        });
      } catch (error) {
        console.error('高亮显示错误:', error);
        return text;
      }
    },
    
    // 药典名称选择
    handlefoucsName() {
      this.drugName();
    },
    
    // 处理下拉框获得焦点事件
    handleSelectFocus(event) {
      console.log('下拉框获得焦点，模式:', this.mode);
      event.preventDefault();
      event.stopPropagation();
      
      // 在编辑模式下，如果当前没有查询条件，加载默认选项
      if (this.mode === 'edit' && !this.currentQuery) {
        this.currentQuery = this.form.drugCodeName || '';
        
        // 如果当前有药典名称，加载当前药典和默认选项
        if (this.currentQuery) {
          this.loadDefaultDrugOptions();
        }
      }
      
      // 手动触发搜索（如果当前没有输入）
      if (!this.currentQuery && this.mode === 'add') {
        this.drugName();
      }
      
      // 使用setTimeout确保事件处理完成后再打开下拉框
      this.$nextTick(() => {
        if (this.$refs.drugNameSelect) {
          // 手动控制下拉框显示
          this.$refs.drugNameSelect.toggleMenu();
        }
      });
    },
    
    // 处理下拉框失去焦点事件
    handleSelectBlur(event) {
      console.log('下拉框失去焦点');
      // 这里不需要阻止默认行为，但可以添加自定义逻辑
    },
    
    // 处理下拉框显示状态变化
    handleSelectVisibleChange(visible) {
      console.log('下拉框显示状态变化:', visible);
      if (visible) {
        // 下拉框显示时的处理
        this.isDropdownOpen = true;
      } else {
        // 下拉框隐藏时的处理
        this.isDropdownOpen = false;
      }
    },
    
    // 修改原来的handleSelectClick方法
    handleSelectClick(event) {
      // 彻底阻止所有事件冒泡和默认行为
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      
      console.log('下拉框点击，完全阻止事件传播');
      
      // 返回false进一步阻止默认行为
      return false;
    },
    
    // 修改原来的handleSelectRightClick方法
    handleSelectRightClick(event) {
      // 彻底阻止右键的所有行为
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      
      // 阻止右键菜单显示
      window.addEventListener('contextmenu', this.blockContextMenu, { once: true });
      
      console.log('下拉框右键点击，完全阻止');
      return false;
    },
    
    // 阻止右键菜单的辅助方法
    blockContextMenu(event) {
      event.preventDefault();
      event.stopPropagation();
    },
    
    // 药典名称搜索
    async drugName(isLoadMore = false) {
      // 在查看模式下，不进行搜索
      if (this.mode === 'view') {
        return;
      }
      
      try {
        if (!isLoadMore) {
          this.loading = true;
          this.pageNum = 1;
        } else {
          this.scrollLoading = true;
        }
        
        const res = await getDInfo({
          productName: this.currentQuery,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        });
        
        if (res.code === 200) {
          if (res.data.content && res.data.content.length > 0) {
            const newData = res.data.content.map(v => ({
              label: v.productName,
              ...v,
              _uid: Math.random().toString(36).substr(2, 9)
            }));
            
            if (isLoadMore) {
              this.NameOptions = [...this.NameOptions, ...newData];
            } else {
              // 在编辑模式下，如果当前有选中的药典，确保它也在列表中
              if (this.mode === 'edit' && this.form.drugCodeId && this.form.drugCodeName) {
                // 检查当前选中的药典是否已经在列表中
                const currentDrugInList = this.NameOptions.find(item => item.id === this.form.drugCodeId);
                if (!currentDrugInList) {
                  // 将当前选中的药典添加到列表开头
                  this.NameOptions = [
                    {
                      id: this.form.drugCodeId,
                      label: this.form.drugCodeName,
                      drugCode: this.form.code || '',
                      specifications: this.form.drugSpec || '',
                      dosageForm: this.form.dosformName || '',
                      approvalNumber: this.form.approvalNumber || '',
                      licensorChinese: this.form.manufacturer || '',
                      _uid: Math.random().toString(36).substr(2, 9)
                    },
                    ...newData
                  ];
                } else {
                  this.NameOptions = newData;
                }
              } else {
                this.NameOptions = newData;
              }
            }
            
            this.hasMore = res.data.content.length >= this.pageSize;
            this.showNoDataPrompt = false;
          } else {
            if (!isLoadMore && this.currentQuery) {
              this.NameOptions = [];
              this.showNoDataPrompt = true;
            } else {
              this.NameOptions = [];
              this.showNoDataPrompt = false;
            }
            this.hasMore = false;
          }
        } else {
          this.$message.error(res.message || '获取药品数据失败');
          this.showNoDataPrompt = false;
        }
      } catch (error) {
        console.error('获取药品数据出错:', error);
        this.$message.error('获取药品数据失败');
        this.showNoDataPrompt = false;
      } finally {
        this.loading = false;
        this.scrollLoading = false;
      }
    },
    
    // 搜索方法
    searchNameMethod: _.debounce(function(query) {
      // 在查看模式下，不进行搜索
      if (this.mode === 'view') {
        return;
      }
      
      this.currentQuery = query.trim();
      this.pageNum = 1;
      
      if (!this.currentQuery) {
        this.isSearchMode = false;
        this.showNoDataPrompt = false;
        
        // 在编辑模式下，如果没有输入查询，加载默认选项
        if (this.mode === 'edit') {
          this.loadDefaultDrugOptions();
        } else {
          // 在新增模式下，清空选项
          this.NameOptions = [];
        }
        return;
      }
      
      this.isSearchMode = true;
      this.showNoDataPrompt = false;
      this.drugName();
    }, 500),
    
    // 滚动到底部
    handleScrollToBottom() {
      if (this.hasMore && !this.scrollLoading) {
        this.pageNum++;
        this.drugName(true);
      }
    },
    
    // 药典选择变化
    async handleNameChange(val) {
      let NameResult = this.NameOptions.find(name => name.id === val);
      console.log('handleNameChange 被调用，NameResult:', NameResult);
      
      this.drugData = NameResult;
      
      if (NameResult) {
        const newKcId = this.mode === 'add' ? 0 : (this.form.kcId || 0);
        this.form.kcId = newKcId;
        this.disablePackingQuantity = Number(newKcId) === 1;
        
        // 重置剂型字段，等待自动填充
        this.form.dosageForm = '';
        this.form.dosformName = NameResult.dosageForm || '';
        
        // 设置药品基本信息
        this.form.code = NameResult.drugCode || '';
        this.form.drugCodeId = NameResult.id || '';
        this.form.drugName = NameResult.label || '';
        this.form.drugCodeName = NameResult.label || '';
        this.form.drugSpec = NameResult.specifications || '';
        this.form.drugType = 1;
        this.form.pyCode = this.getFirstLetter(NameResult.label);
        
        // 关键修改：自动设置药品剂型
        await this.autoSetDosageForm(NameResult);
        
        console.log('药典选择变化后，表单数据:', this.form);
      }
    },
    
    // 自动设置药品剂型
    async autoSetDosageForm(NameResult) {
      if (!NameResult || !NameResult.dosageForm) {
        console.log('药品信息中没有剂型数据，无法自动设置');
        return;
      }
      
      const dosageFormName = NameResult.dosageForm;
      console.log('尝试自动设置剂型，剂型名称:', dosageFormName);
      
      // 如果剂型选项已加载，尝试匹配
      if (this.dosageFormOptions.length > 0) {
        // 查找匹配的剂型
        const matchedDosageForm = this.dosageFormOptions.find(item => 
          item.dosageName === dosageFormName ||
          item.label === dosageFormName ||
          item.dosageFormName === dosageFormName ||
          (item.text && item.text === dosageFormName)
        );
        
        if (matchedDosageForm) {
          console.log('找到匹配的剂型:', matchedDosageForm);
          this.form.dosageForm = matchedDosageForm.id;
          this.form.dosForm = matchedDosageForm.id;
          this.form.dosformName = matchedDosageForm.dosageName || matchedDosageForm.label;
          
          this.$message.success(`已自动设置剂型: ${matchedDosageForm.dosageName || matchedDosageForm.label}`);
        } else {
          // 如果没有找到完全匹配的，尝试部分匹配
          console.log('没有找到完全匹配的剂型，尝试部分匹配');
          this.tryPartialDosageFormMatch(dosageFormName);
        }
      } else {
        console.log('剂型选项未加载，尝试重新加载');
        // 如果剂型选项未加载，重新加载
        await this.loadDosageFormOptions();
        
        // 加载完成后再次尝试设置
        setTimeout(() => {
          this.autoSetDosageForm(NameResult);
        }, 300);
      }
    },
    
    // 尝试部分匹配剂型
    tryPartialDosageFormMatch(dosageFormName) {
      if (!dosageFormName || this.dosageFormOptions.length === 0) {
        return;
      }
      
      // 尝试各种匹配方式
      const searchPatterns = [
        // 完全匹配
        dosageFormName,
        // 去除空格
        dosageFormName.replace(/\s+/g, ''),
        // 提取中文
        dosageFormName.match(/[\u4e00-\u9fa5]+/g)?.join('') || '',
        // 提取数字和单位
        dosageFormName.match(/\d+[a-zA-Z]*/)?.[0] || ''
      ];
      
      for (const pattern of searchPatterns) {
        if (!pattern) continue;
        
        const matchedDosageForm = this.dosageFormOptions.find(item => 
          (item.dosageName && item.dosageName.includes(pattern)) ||
          (item.label && item.label.includes(pattern)) ||
          (item.dosageFormName && item.dosageFormName.includes(pattern))
        );
        
        if (matchedDosageForm) {
          console.log('通过部分匹配找到剂型:', matchedDosageForm);
          this.form.dosageForm = matchedDosageForm.id;
          this.form.dosForm = matchedDosageForm.id;
          this.form.dosformName = matchedDosageForm.dosageName || matchedDosageForm.label;
          
          this.$message.success(`已自动设置剂型: ${matchedDosageForm.dosageName || matchedDosageForm.label}`);
          return;
        }
      }
      
      // 如果没有找到任何匹配，将剂型名称添加到选项中
      console.log('没有找到任何匹配的剂型，将添加新剂型到选项中');
      this.addNewDosageFormOption(dosageFormName);
    },
    
    // 添加新剂型选项
    addNewDosageFormOption(dosageFormName) {
      // 创建一个新的剂型选项
      const newDosageFormId = Date.now(); // 临时ID
      const newOption = {
        id: newDosageFormId,
        dosageName: dosageFormName,
        label: dosageFormName,
        code: 'NEW' + newDosageFormId
      };
      
      // 添加到剂型选项列表
      this.dosageFormOptions.unshift(newOption);
      
      // 设置表单值
      this.form.dosageForm = newDosageFormId;
      this.form.dosForm = newDosageFormId;
      this.form.dosformName = dosageFormName;
      
      this.$message.warning(`已添加新剂型选项: ${dosageFormName}，请确认后保存`);
      
      // 提示用户剂型是新增的
      this.$nextTick(() => {
        this.$message.info('注意：这是一个新的剂型选项，保存时可能需要特殊处理');
      });
    },
    
    // 药品剂型变化
    handleDosageFormChange(val) {
      console.log('药品剂型变化，新值:', val);
      this.form.dosForm = val;
      
      if (val) {
        const selectedOption = this.dosageFormOptions.find(item => item.id === val);
        if (selectedOption) {
          this.form.dosformName = selectedOption.dosageName || selectedOption.label;
          console.log('剂型变化后，设置dosformName为:', this.form.dosformName);
        } else {
          console.warn('没有找到ID为', val, '的剂型选项');
          this.form.dosformName = '';
        }
      } else {
        this.form.dosformName = '';
      }
      
      console.log('剂型变化后，表单数据:', this.form);
    },
    
    // 获取拼音首字母
    getFirstLetter(str) {
      if (!str || typeof str !== 'string') return '';
      
      try {
        const chineseChars = str.match(/[\u4e00-\u9fa5]/g) || [];
        if (chineseChars.length === 0) return '';
        
        const initials = chineseChars.map(char => {
          const pinyinResult = pinyin(char, {
            toneType: 'none',
            type: 'array',
            multiple: false,
          })[0] || '';
          return pinyinResult.charAt(0).toUpperCase();
        });
        
        return initials.join('');
      } catch (error) {
        console.error('拼音转换失败:', error);
        return '';
      }
    },
    
    // 打开快速添加对话框
    async openQuickAddDialog() {
      const drugData = this.drugData || {};
      console.log('openQuickAddDialog - drugData:', drugData);
    
      if (this.dosageFormOptions.length === 0) {
        console.log('剂型选项未加载，先加载');
        await this.loadDosageFormOptions();
      }
    
      this.quickAddForm = {
        manufacturer: drugData.manufacturer || "",
        productName: drugData.drugName || "",
        specifications: drugData.spec || "",
        dosageForm: '',
        approvalLicenceNo: drugData.approvalLicenceNo || this.form?.approvalLicenceNo || '',
      };
    
      const prepnTypeDesc = drugData.prepnTypeDesc || '';
      if (prepnTypeDesc && this.dosageFormOptions.length) {
        const matched = this.dosageFormOptions.find(item =>
          item.dosageName === prepnTypeDesc || item.label === prepnTypeDesc
        );
        if (matched) {
          this.quickAddForm.dosageForm = matched.id;
        }
      }
    
      // 不再需要验证 manufacturerValid
      this.quickAddDialogVisible = true;
    },
	
	openAddManufacturerDialog() {
	  const manufacturerName = this.quickAddForm.manufacturer || '';
	  const approvalNumber = this.drugData?.approvalLicenceNo || this.form?.approvalLicenceNo || '';
	
	  // 设置当前厂家数据，用于 ManFacter 子组件
	  this.currentManufacturer = {
	    manufacturerName: manufacturerName,
	    manuLotnum: approvalNumber,  // 批准文号
	  };
	
	  this.currentDrugData = {
	    drugName: this.quickAddForm.productName,
	    drugId: this.drugData?.drugId || this.form?.drugCodeId,
	    approvalLicenceNo: approvalNumber,
	  };
	
	  this.manufacturerMode = 'add';
	  this.manufacturerDialogVisible = true;
	},
	
	async validateManufacturer() {
	  // 直接从 this.drugData 获取，同时添加 fallback
	  const drugData = this.drugData || {};
	  const drugId = drugData.drugId || this.form?.drugCodeId || '';
	  const approvalNumber = drugData.approvalLicenceNo || this.form?.approvalLicenceNo || '';
	
	  console.log('validateManufacturer - drugId:', drugId, 'approvalNumber:', approvalNumber);
	
	  // 如果没有 drugId 或 approvalNumber，视为验证失败（无法查询）
	  if (!drugId || !approvalNumber) {
	    console.warn('缺少 drugId 或 approvalNumber，无法验证厂家，视为验证失败');
	    this.manufacturerValid = false;
	    this.selectedManufacturer = null;
	    return;
	  }
	
	  try {
	    const res = await getCJSomeWare({ drugId, approvalNumber });
	    console.log('validateManufacturer - 接口返回:', res);
	    if (res.code === 200 && res.data && res.data !== null && res.data !== '') {
	      this.manufacturerValid = true;
	      this.selectedManufacturer = res.data;
	      console.log('厂家验证通过:', this.selectedManufacturer);
	    } else {
	      this.manufacturerValid = false;
	      this.selectedManufacturer = null;
	      console.log('厂家验证失败: 接口返回空数据或无数据');
	    }
	  } catch (error) {
	    console.error('验证厂家失败:', error);
	    this.manufacturerValid = false;
	    this.selectedManufacturer = null;
	  }
	},
	
	// 快速添加对话框关闭
	handleQuickAddClose() {
	  console.log('关闭快速添加对话框');
	  this.quickAddDialogVisible = false;
	  
	  // 关闭后，确保主表单的数据是最新的
	  this.$nextTick(() => {
	    // 如果当前有选择的药品，重新触发一次名称变化，确保数据同步
	    if (this.form.drugCodeId) {
	      console.log('重新触发名称变化，确保数据同步');
	      this.handleNameChange(this.form.drugCodeId);
	    }
	  });
	},
	
    // 处理快速添加
    async handleQuickAddSubmit() {
      try {
        const valid = await this.$refs.quickAddForm.validate();
        if (!valid) {
          this.$message.error('请正确填写快速添加表单');
          return;
        }
    
        this.quickAddLoading = true;
    
        // 开启全局 loading
        const loadingInstance = this.$loading({
          lock: true,
          text: '正在获取厂家信息...',
          background: 'rgba(0, 0, 0, 0.7)'
        });
    
        let loadingTimer = setTimeout(() => {
          loadingInstance.close();
        }, 3000);
    
        const manufacturerName = this.quickAddForm.manufacturer || '';
        if (!manufacturerName) {
          loadingInstance.close();
          clearTimeout(loadingTimer);
          this.$message.warning('厂家名称不能为空');
          this.quickAddLoading = false;
          return;
        }
    
        // 1. 查询生产厂家
        const manufacturerRes = await getManufacturer({
          manufacturerName: manufacturerName,
          pageNum: 1,
          pageSize: 10
        });
    
        console.log('查询生产厂家结果:', manufacturerRes);
    
        let manufacturerId = '';
        let manufacturerData = null;
    
        if (manufacturerRes.code === 200 && manufacturerRes.data && manufacturerRes.data.content && manufacturerRes.data.content.length > 0) {
          const foundManufacturer = manufacturerRes.data.content[0];
          manufacturerId = foundManufacturer.id || foundManufacturer.prodentpId || '';
          manufacturerData = foundManufacturer;
    
          loadingInstance.setText(`成功获取（${manufacturerName}）生产厂家信息`);
          clearTimeout(loadingTimer);
          loadingTimer = setTimeout(() => {
            loadingInstance.close();
          }, 3000);
    
          this.$message.success(`成功获取生产厂家: ${manufacturerName}`);
        } else {
          loadingInstance.close();
          clearTimeout(loadingTimer);
          this.$message.error('当前厂家名称并不存在！请手动添加厂商进行维护！');
          this.quickAddLoading = false;
          return;
        }
    
        // 2. 构建生产厂家表格行数据（通用，用于成功和“已存在”情况）
        const manufacturerRow = {
          id: manufacturerId,
          prodentpId: manufacturerId,
          manufacturer: manufacturerData?.manufacturerName || manufacturerName,
          manufacturerName: manufacturerData?.manufacturerName || manufacturerName,
          status: 1,
          expyDate: '',
          orplc: manufacturerData?.origin || manufacturerData?.orplc || '',
          drugTracB: 0,
          ratio: '',
          bidCnt: '',
          manuLotnum: this.quickAddForm.approvalLicenceNo || this.drugData?.approvalLicenceNo || '',
          netCode: '',
          chsName: '',
          chsCode: '',
          ypId: '',
          regModel: '',
          regSpc: '',
          coding: manufacturerData?.coding || '',
          remark: ''
        };
    
        // 添加厂家到表格（避免重复）
        const exists = this.manufacturerData.some(
          item => item.prodentpId === manufacturerRow.prodentpId
        );
        if (!exists) {
          this.manufacturerData.push(manufacturerRow);
          console.log('已添加生产厂家到表格:', manufacturerRow);
        }
    
        // 3. 调用本位码添加接口
        const submitData = {
          chineseCompany: this.quickAddForm.manufacturer,
          productName: this.quickAddForm.productName,
          specifications: this.quickAddForm.specifications,
          dosageForm: this.quickAddForm.dosageForm,
        };
    
        const res = await addDocTDrugCode(submitData);
    
        if (res.code === 200) {
          // 成功添加本位码
          this.$message.success('本位码信息添加成功！');
    
          const addedDrugData = res.data;
          console.log('快速添加成功返回的数据:', addedDrugData);
    
          // 获取剂型中文名称
          let dosageFormName = '';
          if (this.quickAddForm.dosageForm) {
            const matchedForm = this.dosageFormOptions.find(
              item => item.id === this.quickAddForm.dosageForm
            );
            dosageFormName = matchedForm ? matchedForm.dosageName || matchedForm.label : '';
          }
    
          // 构建成功数据
          const successData = {
            drugId: addedDrugData.id || this.drugData?.drugId || '',
            drugName: addedDrugData.productName || this.quickAddForm.productName || '',
            spec: addedDrugData.specifications || this.quickAddForm.specifications || '',
            pacCnt: this.drugData?.pacCnt || 1,
            approvalLicenceNo: addedDrugData.approvalLicenceNo || this.drugData?.approvalLicenceNo || '',
            dosageFormName: dosageFormName,
            manufacturer: manufacturerData?.manufacturerName || manufacturerName,
            manufacturerId: manufacturerId,
            manufacturerData: manufacturerRow
          };
    
          this.$emit('success', successData);
    
          // 设置当前查询并自动选择药品
          this.currentQuery = addedDrugData.productName || this.quickAddForm.productName;
          await this.drugName();
    
          this.$nextTick(async () => {
            setTimeout(async () => {
              const newDrug = this.NameOptions.find(item =>
                item.label === addedDrugData.productName ||
                item.productName === addedDrugData.productName
              );
              if (newDrug) {
                this.form.drugCodeId = newDrug.id;
                this.form.drugCodeName = newDrug.label || newDrug.productName;
                await this.handleNameChange(newDrug.id);
                this.$message.success(`已自动选择药品: ${newDrug.label || newDrug.productName}`);
              } else if (this.NameOptions.length > 0) {
                const firstOption = this.NameOptions[0];
                this.form.drugCodeId = firstOption.id;
                this.form.drugCodeName = firstOption.label || firstOption.productName;
                await this.handleNameChange(firstOption.id);
                this.$message.success(`已自动选择药品: ${firstOption.label || firstOption.productName}`);
              } else {
                this.$message.warning('未找到对应的药典信息，请手动选择');
              }
              this.quickAddDialogVisible = false;
            }, 500);
          });
    
          clearTimeout(loadingTimer);
          loadingInstance.close();
    
        } else {
          // 本位码添加失败，检查是否因“已存在”
          const errorMessage = res.message || '';
          const keywords = ['已存在', '无需添加', '已记录', '重复', '存在', 'already exists', 'duplicate'];
          const containsKeyword = keywords.some(keyword => errorMessage.includes(keyword));
    
          if (containsKeyword) {
            // 表明本位码已存在，无需重复添加
            this.$message.warning(`本位码信息${errorMessage}，将自动选择已存在的本位码信息`);
    
            // 厂家信息已经添加到表格（前面已执行）
            // 现在自动选择已存在的药品
            this.currentQuery = this.quickAddForm.productName;
            await this.drugName();
    
            this.$nextTick(async () => {
              setTimeout(async () => {
                // 尝试精确匹配
                let existingDrug = this.NameOptions.find(item =>
                  item.productName === this.quickAddForm.productName ||
                  item.label === this.quickAddForm.productName
                );
    
                // 如果没找到，尝试模糊匹配
                if (!existingDrug) {
                  existingDrug = this.NameOptions.find(item =>
                    (item.productName && item.productName.includes(this.quickAddForm.productName)) ||
                    (item.label && item.label.includes(this.quickAddForm.productName))
                  );
                }
    
                if (existingDrug) {
                  this.form.drugCodeId = existingDrug.id;
                  this.form.drugCodeName = existingDrug.label || existingDrug.productName;
                  await this.handleNameChange(existingDrug.id);
                  this.$message.success(`已自动选择已存在的本位码信息: ${existingDrug.label || existingDrug.productName}`);
                } else if (this.NameOptions.length > 0) {
                  // 选第一个
                  const firstOption = this.NameOptions[0];
                  this.form.drugCodeId = firstOption.id;
                  this.form.drugCodeName = firstOption.label || firstOption.productName;
                  await this.handleNameChange(firstOption.id);
                  this.$message.success(`已自动选择药品: ${firstOption.label || firstOption.productName}`);
                } else {
                  this.$message.warning('未找到对应的本位码信息，请手动选择');
                }
    
                // 关闭快速添加模态框
                this.quickAddDialogVisible = false;
    
                // 注意：此时厂家行已经添加到表格，无需额外操作
              }, 500);
            });
    
            // 关闭loading
            clearTimeout(loadingTimer);
            loadingInstance.close();
    
          } else {
            // 其他错误
            this.$message.error(errorMessage || '添加本位码信息失败');
            loadingInstance.close();
          }
        }
    
      } catch (error) {
        console.error('快速添加本位码信息失败:', error);
        this.$message.error('添加本位码信息失败: ' + (error.message || ''));
      } finally {
        this.quickAddLoading = false;
        // loading 已在各分支关闭
      }
    },
	
    // 表单更新
    handleFormUpdate(updatedData) {
      this.form = { ...this.form, ...updatedData };
    },
    
    handleFormUpdateF3(updatedData) {
      this.form = { ...this.form, ...updatedData };
    },
    
    handleFormUpdateF4(updatedData) {
      this.form = { ...this.form, ...updatedData };
    },
    
    // 厂家选择
    handleManufacturerSelect(currentRow) {
      this.currentManufacturer = currentRow;
    },
    
    // 跳转到厂家页面
    goToManufacturerPage(action) {
      this.manufacturerMode = action;
      this.resetManufacturerEditState(); // 重置编辑状态
      this.manufacturerDialogVisible = true;
    },
    
    // 编辑厂家
    handleEditManufacturer(row, index) {
      this.manufacturerMode = 'edit';
      this.currentManufacturer = { ...row };
      this.currentManufacturerIndex = index; // 记录索引
      this.manufacturerDialogVisible = true;
    },
	
    // 删除厂家
    handleDeleteManufacturer(row, index) {
      this.$confirm('确定要删除此生产厂家吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.manufacturerData.splice(index, 1);
        this.$message.success('删除成功');
      }).catch(() => {});
    },
    
    // 厂家保存
    // 在 AddDrugDialog.vue 中，找到 handleManufacturerSave 方法，修改如下：
    async handleManufacturerSave(manufacturerData) {
      // 1. 构建新的厂家对象
      const newManufacturer = {
        id: manufacturerData.prodentpId || manufacturerData.id || '',
        prodentpId: manufacturerData.prodentpId || manufacturerData.id || '',
        // 关键修复：兼容 manufacturerName 和 manufacturer 字段
        manufacturer: manufacturerData.manufacturerName || manufacturerData.label || manufacturerData.manufacturer || '未知厂家',
        manufacturerName: manufacturerData.manufacturerName || manufacturerData.label || manufacturerData.manufacturer || '',
        coding: manufacturerData.coding || '',
        orplc: manufacturerData.orplc || '',
        expyDate: manufacturerData.expyDate || '',
        status: manufacturerData.status !== undefined ? manufacturerData.status : 1,
        drugTracMinId: manufacturerData.drugTracMinId || '',
        drugTracMaxId: manufacturerData.drugTracMaxId || '',
        drugTracMaxCnt: manufacturerData.drugTracMaxCnt || '',
        drugTracB: manufacturerData.drugTracB !== undefined ? manufacturerData.drugTracB : 0,
        ratio: manufacturerData.ratio || '',
        bidCnt: manufacturerData.bidCnt || '',
        manuLotnum: manufacturerData.manuLotnum || '',
        netCode: manufacturerData.netCode || '',
        chsName: manufacturerData.chsName || '',
        chsCode: manufacturerData.chsCode || '',
        ypId: manufacturerData.ypId || '',
        regModel: manufacturerData.regModel || '',
        regSpc: manufacturerData.regSpc || '',
        remark: manufacturerData.remark || ''
      };
    
      // 2. 根据模式更新数据
      if (this.manufacturerMode === 'edit' && this.currentManufacturerIndex >= 0) {
        this.manufacturerData.splice(this.currentManufacturerIndex, 1, newManufacturer);
        this.$message.success('厂家信息更新成功');
      } else {
        this.manufacturerData.push(newManufacturer);
        this.$message.success('厂家添加成功');
      }
    
      // 3. 重新验证厂家是否存在
      await this.validateManufacturer();
    
      // 4. 关闭模态框
      this.manufacturerDialogVisible = false;
      this.resetManufacturerEditState();
    
      // 5. 如果快速添加对话框打开，更新状态
      if (this.quickAddDialogVisible) {
        if (this.manufacturerValid === true) {
          this.$message.success('生产厂家验证通过，可以继续添加');
        }
      }
    },
    
	// 重置厂家编辑状态
	resetManufacturerEditState() {
	  this.currentManufacturer = null;
	  this.currentManufacturerIndex = -1;
	  this.manufacturerMode = 'add';
	},
	
    // 厂家关闭
    handleManufacturerClose() {
      this.manufacturerDialogVisible = false;
      this.resetManufacturerEditState();
    },
	
    // 提交表单
    async submitForm() {
      this.$refs.topForm.validate(async (valid) => {
        if (!valid) {
          this.$message.error('请将药品档案基本信息中所需的必填信息填写完毕！');
          return;
        }
        
        try {
          this.loading = true;
          const submitData = this.buildSubmitData();
          
          let response;
          if (this.mode === 'add') {
            response = await addDrugInformation(submitData);
          } else {
            response = await updateDrugInformation(submitData);
          }
          
          if (response.code === 200) {
            this.$message.success(this.mode === 'add' ? '新增成功' : '保存成功');
            this.dialogVisible = false;
            this.$emit('refresh');
          } else {
            this.$message.error(response.message);
          }
        } catch (error) {
          console.error('保存失败:', error);
          this.$message.error('保存失败: ' + error.message);
        } finally {
          this.loading = false;
        }
      });
    },
    
    // 构建提交数据
    buildSubmitData() {
      const formData = JSON.parse(JSON.stringify(this.form));
      const manufacturerData = this.manufacturerData.map(item => ({
        ...item,
        drugId: this.form.id,
        drugName: this.form.drugName || this.form.name
      }));
      
      return {
        ...formData,
        list: manufacturerData,
        state: Number(formData.state || 1),
        kcId: Number(formData.kcId || 0)
      };
    },
    
    // 关闭对话框
    handleClose() {
      console.log('关闭AddDrugDialog主对话框');
      this.dialogVisible = false;
      
      // 同时关闭快速添加对话框
      this.quickAddDialogVisible = false;
      
      this.resetForm();
      this.resetManufacturerEditState();
      this.$emit('refresh');
    },
    
    // 重置表单
    resetForm() {
      this.form = {
        state: 1,
        kcId: 0,
        drugCodeId: '',
        drugCodeName: '', // 新增字段
        dosageForm: '',
        drugType: 1,
        drugName: '',
        code: '',
        drugSpec: '',
        dosForm: '',
        pyCode: '',
        mrsId: '',
        expensiveType: 1, // 重置为默认值1（普价）
      };
      
      this.NameOptions = [];
      this.currentQuery = '';
      this.pageNum = 1;
      this.manufacturerData = [];
      this.currentManufacturer = null;
    }
  }
};
</script>

<style lang="less" scoped>
	.add-drug-container {

		/* 全局样式优化 */
		::v-deep * {
			box-sizing: border-box;
		}

		/* 对话框样式 */
		::v-deep .el-dialog {
			border-radius: 8px !important;
			overflow: hidden;
			
			/* 设置对话框整体高度 */
			height: 80vh;
			display: flex;
			flex-direction: column;

			.el-dialog__header {
				padding: 12px 20px 12px 20px !important; /* 调整内边距 */
				background: linear-gradient(135deg, #00557f 0%, #ebfaff 100%);
				border-top-left-radius: 8px;
				border-top-right-radius: 8px;
				flex-shrink: 0;
				position: relative; /* 相对定位 */

				.dialog-header {
					display: flex;
					justify-content: space-between;
					align-items: center;
					width: 100%;

					.dialog-header-title {
						color: #fff;
						font-size: 16px;
						font-weight: bold;
					}

					.header-buttons {
						.close-button {
							color: #fff;
							padding: 0;
							width: 20px;
							height: 20px;
							font-size: 16px;
						}
					}
				}
			}

			.el-dialog__body {
				padding: 0 !important; /* 移除内边距，由内部容器控制 */
				flex: 1;
				overflow: hidden;
				display: flex;
				flex-direction: column;
			}
			
			.dialog-footer {
				flex-shrink: 0;
			}
		}

		.dialog-content {
			display: flex;
			flex-direction: column;
			height: 100%;
			overflow: hidden;
			
			/* 上半部分：药品表单 - 占60%高度 */
			.top-section {
				flex: 0 0 60%; /* 固定占60% */
				display: flex;
				flex-direction: column;
				min-height: 0; /* 重要：确保子元素可以正确收缩 */
				overflow: hidden; /* 防止内容溢出 */
				padding: 12px; /* 添加内边距 */
				
				.form-top {
					flex: 1;
					display: flex;
					flex-direction: column;
					min-height: 0; /* 确保表单可以正确收缩 */
					overflow: hidden; /* 隐藏溢出的内容 */
					
					.el-form {
						width: 100%;
						height: 100%; /* 确保表单填充高度 */
						display: flex;
						flex-direction: column;
						min-height: 0; /* 确保表单可以正确收缩 */
						
						/* 第一行：药典名称、药品剂型、药品类型 - 左对齐 */
						.fixed-form-row {
							margin-bottom: 12px;
							padding: 0;
							display: flex;
							align-items: stretch;
							border: 1px solid #dcdfe6;
							border-radius: 4px;
							overflow: hidden;
							flex-shrink: 0; /* 不收缩 */
						}

						.el-col {
							padding: 0;
							border-right: 1px solid #dcdfe6;

							&:first-child {
								border-left: 1px solid #dcdfe6;
							}

							&:last-child {
								border-right: 1px solid #dcdfe6;
							}
						}

						.el-form-item {
							margin-bottom: 0;
							display: flex;
							align-items: stretch;
							width: 100%;
							height: 100%;

							&.form-item-with-border {
							  display: flex;
							  align-items: stretch;
							  height: 100%;
							  
							  /* Label样式优化 - 类似表格表头 */
							  ::v-deep .el-form-item__label {
							    background-color: #f5f7fa;
							    border: none;
							    padding: 0 8px;
							    line-height: 32px;
							    height: 100%;
							    font-weight: bold;
							    color: #00557f;
							    width: 100px;
							    text-align: right;
							    display: flex;
							    align-items: center;
							    justify-content: flex-end;
							    font-size: 12px;
							    border-right: 1px solid #dcdfe6;
							    white-space: nowrap;
							    overflow: hidden;
							    text-overflow: ellipsis;
							  }
							  
							  /* Content样式优化 - 类似表格单元格 */
							  ::v-deep .el-form-item__content {
							    border: none;
							    line-height: 32px;
							    height: 100%;
							    flex: 1;
							    margin-left: 0 !important;
							    display: flex;
							    align-items: stretch;
							    
							    .el-select, .el-input {
							      width: 100%;
							      height: 100%;
							      
							      .el-input__inner {
							        border: none;
							        height: 100%;
							        line-height: 30px;
							        padding: 0 8px;
							        font-size: 12px;
							        color: #606266;
							        
							        &:focus {
							          outline: none;
							          box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
							        }
							      }
							      
							      .el-input__suffix {
							        display: flex;
							        align-items: center;
							        right: 5px;
							      }
							      
							      /* 下拉框样式优化 */
							      .el-select-dropdown {
							        z-index: 9999 !important;
							        border: 1px solid #dcdfe6;
							        border-radius: 4px;
							        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
							        overflow: hidden;
							        
							        /* 下拉框整体布局 */
							        .el-select-dropdown__wrap {
							          max-height: 300px;
							          overflow-y: auto;
							        }
							        
							        /* 固定表头容器 */
							        .select-header-wrapper {
							          position: sticky;
							          top: 0;
							          z-index: 10;
							          background-color: #fff;
							          border-bottom: 1px solid #dcdfe6;
							        }
							        
							        /* 固定表头样式 */
							        .select-header {
							          display: flex;
							          width: 100%;
							          background-color: #f5f7fa;
							          border-bottom: 1px solid #dcdfe6;
							          
							          .header-item {
							            flex: 1;
							            text-align: center;
							            padding: 8px 4px;
							            color: #00557f;
							            font-size: 12px;
							            font-weight: bold;
							            white-space: nowrap;
							            overflow: hidden;
							            text-overflow: ellipsis;
							            border-right: 1px solid #dcdfe6;
							            min-width: 0;
							            
							            &:last-child {
							              border-right: none;
							            }
							          }
							        }
							        
							        /* 选项列表容器 */
							        .el-select-dropdown__list {
							          padding: 0;
							          margin: 0;
							        }
							        
							        /* 单个选项样式 */
							        .el-select-dropdown__item {
							          padding: 0;
							          height: 28px;
							          line-height: 28px;
							          display: flex;
							          align-items: stretch;
							          border-bottom: 1px solid #f0f0f0;
							          
							          &:last-child {
							            border-bottom: none;
							          }
							          
							          &:hover, &.hover {
							            background-color: #f5f7fa;
							          }
							          
							          &.selected {
							            background-color: #ecf5ff;
							            color: #409EFF;
							            font-weight: bold;
							          }
							          
							          /* 选项行样式 */
							          .option-row {
							            display: flex;
							            width: 100%;
							            height: 100%;
							            
							            .option-item {
							              flex: 1;
							              text-align: center;
							              padding: 0 4px;
							              font-size: 12px;
							              white-space: nowrap;
							              overflow: hidden;
							              text-overflow: ellipsis;
							              border-right: 1px solid #f0f0f0;
							              display: flex;
							              align-items: center;
							              justify-content: center;
							              min-width: 0;
							              
							              &:last-child {
							                border-right: none;
							              }
							              
							              /* 高亮文本样式 */
							              span[style*="background-color: #fffe76"] {
							                display: inline;
							                padding: 0 1px;
							              }
							            }
							          }
							        }
							        
							        /* 无数据提示样式 */
							        .no-data-prompt {
							          padding: 20px;
							          text-align: center;
							          color: #606266;
							          font-size: 12px;
							          
							          i {
							            font-size: 36px;
							            color: #e6a23c;
							            margin-bottom: 8px;
							            display: block;
							          }
							          
							          p {
							            margin: 8px 0;
							          }
							          
							          .highlight-query {
							            color: #409EFF;
							            font-weight: bold;
							          }
							          
							          .quick-add-link {
							            color: #409EFF;
							            font-size: 12px;
							            text-decoration: underline;
							            cursor: pointer;
							            margin-top: 8px;
							            display: inline-block;
							            
							            &:hover {
							              color: #66b1ff;
							            }
							          }
							        }
							        
							        /* 加载更多提示 */
							        .load-more {
							          text-align: center;
							          padding: 8px;
							          color: #909399;
							          font-size: 12px;
							          
							          i {
							            margin-right: 4px;
							          }
							        }
							      }
							    }
							  }
							}
						}
						
						/* 标签页固定高度容器 - 关键修改 */
						.tab-content-fixed-height {
							flex: 1;
							display: flex;
							flex-direction: column;
							min-height: 0; /* 允许收缩 */
							overflow: hidden; /* 隐藏溢出的内容 */
							position: relative; /* 相对定位，用于内部绝对定位 */
							
							/* 标签页区域 - 关键修改：绝对定位填满容器 */
							.form-tabs {
								position: absolute; /* 绝对定位填满容器 */
								top: 0;
								left: 0;
								right: 0;
								bottom: 0;
								display: flex;
								flex-direction: column;
								
								/* 标签页头部样式 - 与生产厂家信息保持一致 */
								::v-deep .el-tabs__header {
									margin: 0 0 8px 0;
									flex-shrink: 0; /* 不收缩 */
									background-color: #f5f7fa; /* 背景色与生产厂家信息保持一致 */
									border-radius: 4px;
									padding: 6px 12px;
									
									.el-tabs__nav-wrap {
										&::after {
											display: none; /* 隐藏底部边框 */
										}
									}
									
									.el-tabs__item {
										font-weight: bold;
										color: #00557f; /* 文字颜色与生产厂家信息保持一致 */
										font-size: 13px;
										padding: 0 16px;
										height: 32px;
										line-height: 32px;
										
										&.is-active {
											color: #00557f;
											background-color: #fff;
											border-radius: 4px;
											border: 1px solid #e0e0e0;
											border-bottom: none;
										}
										
										&:hover {
											color: #00557f;
										}
									}
								}
								
								/* 标签页内容区域 - 关键修改：固定高度并显示滚动条 */
								::v-deep .el-tabs__content {
									flex: 1;
									display: flex;
									flex-direction: column;
									min-height: 0; /* 允许收缩 */
									overflow: hidden; /* 隐藏溢出的内容 */
									position: relative; /* 相对定位 */
									
									/* 为每个标签页内容添加滚动容器 */
									.basic-info,
									.kz-info,
									.use-info {
										position: absolute; /* 绝对定位填满容器 */
										top: 0;
										left: 0;
										right: 0;
										bottom: 0;
										display: flex;
										flex-direction: column;
										overflow: hidden; /* 隐藏溢出的内容 */
										
										/* 子组件内部的滚动容器 - 关键修改：由父容器控制滚动 */
										.basic-info-container {
											flex: 1;
											display: flex;
											flex-direction: column;
											min-height: 0; /* 允许收缩 */
											overflow-y: auto; /* 垂直滚动 */
											overflow-x: hidden; /* 隐藏水平滚动 */
											border: 1px solid #e8e8e8;
											border-radius: 4px;
											padding: 12px;
											box-sizing: border-box;
											
											/* 滚动条样式 */
											&::-webkit-scrollbar {
												width: 8px;
												height: 8px;
											}
											
											&::-webkit-scrollbar-track {
												background: #f5f5f5;
												border-radius: 4px;
											}
											
											&::-webkit-scrollbar-thumb {
												background: #c1c1c1;
												border-radius: 4px;
												
												&:hover {
													background: #a8a8a8;
												}
											}
											
											/* 针对Firefox的滚动条样式 */
											scrollbar-width: thin;
											scrollbar-color: #c1c1c1 #f5f5f5;
										}
									}
								}
							}
						}
					}
				}
			}
			
			/* 下半部分：生产厂家表格 - 占40%高度 */
			.bottom-section {
				flex: 0 0 40%; /* 固定占40% */
				display: flex;
				flex-direction: column;
				min-height: 0; /* 允许收缩 */
				overflow: hidden; /* 确保不会溢出 */
				padding: 0 12px 12px 12px; /* 添加上左右下内边距 */
				
				.section-header {
					padding: 10px 0;
					display: flex;
					justify-content: space-between;
					align-items: center;
					background: #f5f7fa;
					flex-shrink: 0; /* 不收缩 */

					.section-title {
						display: flex;
						align-items: center;

						span {
							font-weight: bold;
							color: #00557f;
							font-size: 14px;
						}
					}

					.section-actions {
						.el-button {
							padding: 6px 12px;
							font-size: 12px;
						}
					}
				}

				.manufacturer-table {
					flex: 1;
					overflow: auto; /* 允许滚动 */
					min-height: 0; /* 允许收缩 */

					::v-deep .el-table {
						height: auto !important; /* 改为auto */
						font-size: 12px;
						min-height: 150px; /* 设置最小高度 */

						.el-table__header-wrapper,
						.el-table__body-wrapper {
							font-size: 12px;
						}

						th,
						td {
							padding: 6px 0;
							font-size: 12px;
						}

						.cell {
							font-size: 12px;
							padding: 0 8px;
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
						}

						.el-button--text {
							padding: 0 4px;
							font-size: 12px;
						}
					}
					
					/* 表格容器的滚动条样式 */
					&::-webkit-scrollbar {
						width: 8px;
						height: 8px;
					}
					
					&::-webkit-scrollbar-track {
						background: #f5f5f5;
						border-radius: 4px;
					}
					
					&::-webkit-scrollbar-thumb {
						background: #c1c1c1;
						border-radius: 4px;
						
						&:hover {
							background: #a8a8a8;
						}
					}
					
					/* 针对Firefox的滚动条样式 */
					scrollbar-width: thin;
					scrollbar-color: #c1c1c1 #f5f5f5;
				}
			}
		}

		/* 底部按钮区域 */
		.dialog-footer {
			padding: 12px;
			border-top: 1px solid #ebeef5;
			text-align: right;

			.el-button {
				font-size: 12px;
			}
		}
	}
</style>